import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { getOrderingFlowType } from '../../../../utilities/function/configuration'
import { getCID, getDataFromURL } from '../../../../utilities/function/urlparams'

import {
  CUSTOM_HOSTING_FLOW,
  EMAIL_HOSTING_FLOW,
  GSUITE_FLOW,
  VPS_FLOW
} from '../../../../utilities/function/productFlow'
import CustomHostingConfig from './customhosting'
import VPSConfig from './vps'
import GSuiteConfig from './gsuite'
import EmailHostingConfig from './emailhosting'

//  This Component is Responsible for configuring the product (not domain),
//  unless handed the configuration to the site-connector (currently only for select hosting)
let SelectConfigOptions = (props) =>{
  const {location} = props
  const configurations = useSelector(state=>(state.app.configurations))

  const renderMain = () =>{
    const urlparams = getDataFromURL(location.search)
    const cid = getCID(urlparams)
    const productConfig = configurations[cid]
    if(productConfig && productConfig.selectedProduct && productConfig.selectedProduct.id){
      const {id} = productConfig.selectedProduct
      const productFlow = getOrderingFlowType(id)
      switch(productFlow){
        case CUSTOM_HOSTING_FLOW:
          return (<CustomHostingConfig/>)
        case VPS_FLOW:
          return (<VPSConfig />)
        case GSUITE_FLOW:
          return (<GSuiteConfig />)
        case EMAIL_HOSTING_FLOW:
          return (<EmailHostingConfig />)
        default:
          return (<></>)
      }
    }
    return (<></>)
  }
  return(
    <div className={'of-select-config-options of-step'}>
      {renderMain()}
    </div>
  )
}


SelectConfigOptions.propTypes ={
  location: PropTypes.any
}

SelectConfigOptions = withRouter(SelectConfigOptions)

export default SelectConfigOptions